import gql from 'graphql-tag';

import { FULL_COMMENT_FRAGMENT } from '../fragments/Comment/fullComment';

export const GET_POST_COMMENTS_QUERY = gql`
  query GetPostComments($postId: String!) {
    loggedIn {
      postById(postId: $postId) {
        id
        deleted
        comments {
          ...fullComment
        }
      }
    }
  }
  ${FULL_COMMENT_FRAGMENT}
`;

export { useGetPostCommentsQuery } from '../gen/types';
